import { useAppSelector } from "@/hooks";
import { currentUser } from "@/store/appSlice";
import { useNavigate } from "react-router-dom";

const Page404 = () => {
  const user = useAppSelector(currentUser);
  const navigate = useNavigate();

  const handleBackToHome = () => navigate("/");
  const handleBackToContent = () => navigate("/content");
  const handleBackToUsers = () => navigate("/users");

  return (
    <div>
      {
        !user?.claims?.isAdmin && user?.claims?.isUserManageAdmin ? (
          <button onClick={handleBackToContent}>前の画面に戻る</button>
        ) : !user?.claims?.isAdmin && user?.claims?.isContentManageAdmin ? (
          <button onClick={handleBackToUsers}>前の画面に戻る</button>
        ) : <button onClick={handleBackToHome}>前の画面に戻る</button>
      }
    </div>
  );
};

export default Page404;
